import React from 'react'


function Character () {
  return(
    <div className = "char">
      <br />
      <h1 className="swCharTitle"> Your Star Wars Character is: </h1>
    </div>
  )
}

export default Character
